import React, { useMemo, useState, useEffect, useRef } from "react";
import columns from "./TelevisiteColumns";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Assignment as AssignmentIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Email as EmailIcon,
} from "@mui/icons-material";
import {
  Paper,
  Box,
  Button,
  MenuItem,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  Typography,
} from "@mui/material";
import { useAuthHeader, useAuthUser } from "react-auth-kit";
import {
  AddTelevisit,
  ViewTelevisit,
  useDeleteTelevisit,
  useGetTelevisits,
  usePutTelevisit,
  useResendTelevisitInvitations,
} from "../../components/TelevisitComponents";
import {
  LoadingError,
  LoadingPaper,
  EmptyPaper,
} from "../../components/LoadingComponents";
import MaterialReactTable from "material-react-table";
import { useGetPatients } from "../../components/PatientComponents";
import { useEditMode } from "../../components/EditableComponents";
import getColumns from "./TelevisiteColumns";

function Televisite(props) {
  // === authentication ===
  const authUser = useAuthUser();

  // === web service queries/mutations ===
  const patientsQuery = useGetPatients();
  const televisitsQuery = useGetTelevisits();
  const deleteMutation = useDeleteTelevisit();
  const resendInvitationsMutation = useResendTelevisitInvitations();

  // === AddTelevisit modal handling ===
  const [openAddTelevisit, setOpenAddTelevisit] = useState(false);
  const _editMode = useRef(false);

  const [selectedTelevisit, setSelectedTelevisit] = useState(null);
  const editModeTelevisitMutation = usePutTelevisit(selectedTelevisit);
  const handleOpenAddTelevisit = () => {
    setOpenAddTelevisit(true);
  };
  const handleCloseAddTelevisit = () => {
    setOpenAddTelevisit(false);
  };

  // === EditMode handling ===
  const {
    editMode,
    enterEditMode,
    cancelEditMode,
    confirmEditMode,
    updateEditState,
    setQueryKey,
  } = useEditMode({
    editModeEnabled: _editMode.current,
    updateMutation: editModeTelevisitMutation,
    initialQueryKey: ["televisits", selectedTelevisit],
  });

  const tableColumns = getColumns(editMode, updateEditState);

  return (
    <main style={{ width: "100%" }}>
      <Dialog open={openAddTelevisit}>
        <AddTelevisit closeModal={handleCloseAddTelevisit} />
      </Dialog>

      <PageTitle title="Televisite" />
      <Paper
        style={{ minHeight: "fitContent", margin: "3vh", maxWidth: "96%" }}
      >
        <Box>
          <Button
            style={{ margin: "15px" }}
            color="primary"
            onClick={handleOpenAddTelevisit}
            variant="contained"
          >
            NUOVA TELEVISITA
          </Button>
        </Box>

        {televisitsQuery.isLoading || patientsQuery.isLoading ? (
          <LoadingPaper />
        ) : televisitsQuery.isError || patientsQuery.isError ? (
          <LoadingError error={televisitsQuery.error} />
        ) : televisitsQuery.isSuccess &&
          televisitsQuery.data.televisits.length === 0 ? (
          <EmptyPaper message={"Nessuna televisita in programma"} />
        ) : (
          <MaterialReactTable
            columns={tableColumns}
            data={
              televisitsQuery.data?.televisits.map((el) => {
                return { ...el };
              }) || []
            }
            initialState={{
              density: "compact",
              showColumnFilters: true,
              columnVisibility: {
                professionista_sanitario: authUser()?.role !== 3,
              },
            }}
            enablePagination={true}
            enableBottomToolbar={true}
            enableTopToolbar={false}
            enableSorting={true}
            muiTablePaperProps={{
              elevation: 0,
            }}
            enableColumnResizing
            enableColumnActions={false}
            enableRowSelection={false}
            enableRowActions={true}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Azioni" },
            }}
            positionActionsColumn="last"
            renderRowActionMenuItems={({ closeMenu, row, table }) => [
              <MenuItem
                key="edit"
                color={
                  editMode === row.original.id ? "success" : "warning"
                }
                onClick={() => {
                  const televisitId = row.original.id;
                  if (editMode === televisitId) {
                    confirmEditMode();
                  } else {
                    if (editMode) cancelEditMode();
                    setSelectedTelevisit(televisitId);
                    setQueryKey(["televisits", televisitId]);
                    enterEditMode(televisitId);
                    row.toggleExpanded(true);
                  }
                  closeMenu();
                }}
              >
                <IconButton>
                  {" "}
                  <EditIcon
                    color={
                      editMode === row.original.id ? "success" : "warning"
                    }
                  />
                </IconButton>
                {editMode === row.original.id
                  ? "Conferma modifiche"
                  : "Modifica televisita"}
              </MenuItem>,

              <MenuItem
                key="delete"
                onClick={() => {
                  deleteMutation.mutate(row.original.id);
                  closeMenu();
                }}
              >
                <IconButton>
                  {" "}
                  <DeleteIcon color="error" />
                </IconButton>
                Rimuovi televisita
              </MenuItem>,

              <MenuItem key="report" onClick={() => console.log("report")}>
                <IconButton>
                  {" "}
                  <AssignmentIcon color="primary" />
                </IconButton>{" "}
                Scarica report
              </MenuItem>,
              ...(row.original.can_view_all_links ? [
                <MenuItem
                  key="resend-invitations"
                  onClick={() => {
                    resendInvitationsMutation.mutate(row.original.id);
                    closeMenu();
                  }}
                >
                  <IconButton>
                    <EmailIcon color="primary" />
                  </IconButton>
                  Reinvia inviti
                </MenuItem>
              ] : []),
            ]}
            renderDetailPanel={({ row }) => {
              return (
                <ViewTelevisit
                  editMode={editMode === row.original.id}
                  updateEditState={updateEditState}
                  televisit_id={row.original.id}
                />
              );
            }}
          />
        )}
      </Paper>
    </main>
  );
}

export default Televisite;
